import { EditProjectContextProps } from "../../EditProjectContext";
import { getLtlWithFetchedBidpack } from "./GetLtlWithFetchedBidpack";

export async function setAllLtlBidpacks({
  project,
  setProject,
}: EditProjectContextProps) {
  // eslint-disable-next-line no-restricted-syntax
  for await (let ltlPipeline of project?.ltlPipelines || []) {
    if (ltlPipeline.LtlBidpack) {
      return;
    }

    ltlPipeline = await getLtlWithFetchedBidpack(
      ltlPipeline,
      project.StartDateDisplay
    );
  }
  setProject(project);
}
